import { SvgIcon, type SvgIconProps } from "@mui/material";
import type { FC } from "react";

export const AnalyticsIcon: FC<SvgIconProps> = (props) => {
	return (
		<SvgIcon {...props}>
			<svg viewBox="0 0 125 124" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="64" y="56" width="42" height="57" rx="8" fill="#E3E7E9" />
				<rect x="14" y="76" width="42" height="48" rx="8" fill="#E3E7E9" />
				<rect x="64" width="42" height="48" rx="8" fill="#E3E7E9" />
				<rect x="14" y="10" width="42" height="58" rx="8" fill="#E3E7E9" />
				<path
					d="M4 76.5686C4 76.5686 18.8313 50.5882 34.4615 50.5882C50.0385 50.5882 50.9484 88 71.5 88C92.6154 88 107.154 60.2876 121 35"
					stroke="#BDBDBD"
					strokeWidth="8"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</SvgIcon>
	);
};
